var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }, [
          _c(
            "div",
            { staticClass: "page-name", attrs: { id: "benefitHeader" } },
            [_vm._v(_vm._s(_vm.pageTitle))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "back_button btn btn-primary pull-right",
              attrs: { type: "submit" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.buttonBack.apply(null, arguments)
                }
              }
            },
            [_vm._v("Back")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("form", { attrs: { id: "changeProfile" } }, [
            _c("div", { staticClass: "forms-container" }, [
              _c("div", { staticClass: "row no-margin" }, [
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c(
                        "v-select",
                        {
                          attrs: {
                            name: "categoryId",
                            id: "categoryId",
                            label: "text",
                            filterable: false,
                            options: _vm.categoryArr,
                            placeholder: "Select Category"
                          },
                          on: {
                            change: _vm.changedValue,
                            input: function($event) {
                              return _vm.changedCategoryFor()
                            },
                            search: _vm.onSearchCategory
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "option",
                              fn: function(option) {
                                return [
                                  _c("div", { staticClass: "d-center" }, [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(option.text) +
                                        "\n                                        "
                                    )
                                  ])
                                ]
                              }
                            },
                            {
                              key: "selected-option",
                              fn: function(option) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "selected d-center" },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(option.text) +
                                          "\n                                        "
                                      )
                                    ]
                                  )
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.categoryId,
                            callback: function($$v) {
                              _vm.categoryId = $$v
                            },
                            expression: "categoryId"
                          }
                        },
                        [
                          _c("template", { slot: "no-options" }, [
                            _vm._v(
                              "\n                                        Search Category...\n                                    "
                            )
                          ])
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.categoryError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("v-select", {
                        attrs: {
                          name: "status",
                          id: "status",
                          label: "text",
                          filterable: false,
                          options: _vm.statusArr,
                          placeholder: "Select Status"
                        },
                        on: {
                          input: function($event) {
                            return _vm.changedStatus()
                          }
                        },
                        model: {
                          value: _vm.status,
                          callback: function($$v) {
                            _vm.status = $$v
                          },
                          expression: "status"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.statusError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("v-select", {
                        attrs: {
                          name: "locationType",
                          id: "locationType",
                          label: "text",
                          clearable: false,
                          searchable: false,
                          filterable: false,
                          options: _vm.locationTypeArr,
                          placeholder: "Select Location Type"
                        },
                        model: {
                          value: _vm.locationType,
                          callback: function($$v) {
                            _vm.locationType = $$v
                          },
                          expression: "locationType"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 forms-block" }, [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.imageTitle,
                            expression: "imageTitle"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "imageTitle",
                          placeholder: "Video Title"
                        },
                        domProps: { value: _vm.imageTitle },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.imageTitle = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.imageTitleError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 forms-block" }, [
                  _vm._m(4),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.websiteLink,
                            expression: "websiteLink"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "websiteLink",
                          placeholder: "Website Link"
                        },
                        domProps: { value: _vm.websiteLink },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.websiteLink = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.websiteLinkError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 forms-block" }, [
                  _vm._m(5),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("vue-dropzone", {
                        ref: "dropzone",
                        attrs: {
                          id: "drop1",
                          options: _vm.dropzoneOptions,
                          destroyDropzone: false,
                          headers: _vm.dropzoneOptions.headers,
                          name: "file"
                        },
                        on: {
                          "vdropzone-removed-file": _vm.removedSelectedFile,
                          "vdropzone-success": _vm.vfileSuccess,
                          "vdropzone-duplicate-file": _vm.vduplicateFile,
                          "vdropzone-total-upload-progress": _vm.progressOfUload
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.imageUploadError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 forms-block" }, [
                  _vm._m(6),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-9 paddingleft0" },
                    [
                      _c("tinymce", {
                        ref: "tm",
                        attrs: {
                          plugins: [
                            "advlist autolink lists link image charmap print preview hr anchor pagebreak",
                            "searchreplace wordcount visualblocks visualchars code fullscreen",
                            "insertdatetime media nonbreaking save table contextmenu directionality",
                            "template paste textcolor colorpicker textpattern imagetools toc help emoticons hr codesample"
                          ],
                          id: "description",
                          other_options: _vm.options
                        },
                        model: {
                          value: _vm.description,
                          callback: function($$v) {
                            _vm.description = $$v
                          },
                          expression: "description"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "requiredstar" }, [_vm._v("*")]),
                      _vm._v(" "),
                      _c("font", { staticClass: "text-danger" }, [
                        _vm._v(_vm._s(_vm.descriptionError))
                      ])
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm._m(7),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c("div", { staticClass: "col-12 paddingleft0" }, [
                    _c("input", {
                      staticClass: "btn btn-primary",
                      attrs: {
                        id: "addBenifitBtn",
                        type: "submit",
                        value: "Save"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.add401kVideo()
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "btn btn-primary",
                      attrs: {
                        id: "addAndContinueBenifitBtn",
                        type: "submit",
                        value: "Save and Continue"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.add401kVideo(
                            (_vm.flag = "Save and Continue")
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "back_button btn btn-primary",
                      attrs: {
                        id: "CancelBenifit",
                        type: "submit",
                        value: "Cancel"
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.buttonBack.apply(null, arguments)
                        }
                      }
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("app-backend-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "categories" } }, [
        _vm._v("Category :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "status" } }, [
        _vm._v("Status :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "locationType" } }, [
        _vm._v("Location Type :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "imageTitle" } }, [
        _vm._v("Video Title :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "websiteLink" } }, [
        _vm._v("Website Link :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "drop1" } }, [
        _vm._v("Upload Video Image :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-3 paddingleft0" }, [
      _c("div", { staticClass: "form-label", attrs: { for: "description" } }, [
        _vm._v("Description :")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "col-12 paddingleft0" }, [
        _c(
          "div",
          { staticClass: "alert alert-danger", attrs: { id: "alertError" } },
          [_c("strong", { staticClass: "error", attrs: { id: "errorMsg" } })]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-102f5f19", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-102f5f19","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/backend/401kvideos/Add401kVideos.vue
// module id = null
// module chunks = 